// @flow
import React, { Component } from 'react'
import AdditionalParamsTextArea from './AdditionalParamsTextArea'
import HintWrapper from '../controls/HintWrapper'

type Props = {|
  errors: Array<string>,
  value: string,
  onChange: (string) => void
|}

const t = {
  vk_apps: 'Исключить приложения ВКонтакте',
  vk_apps_hint:
    'Вы можете исключить из показа рекламы пользователей, установивших выбранные приложения ВКонтакте. Для выбора приложений укажите их ID'
}

export default class ExcludedVkAppsTextArea extends Component<Props> {
  render() {
    return (
      <AdditionalParamsTextArea
        htmlId="audience_excluded_vk_apps"
        label={this.renderLabelBlock()}
        maxRows={10}
        value={this.props.value}
        errors={this.props.errors}
        onChange={(value) => this.props.onChange(value)}
      />
    )
  }

  renderLabelBlock() {
    return <HintWrapper triggerText={t.vk_apps} popupText={t.vk_apps_hint} alignLeft />
  }
}
